import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {UniversityFeeDetailsService} from '../../../shared/services/university-fee-details.service';
import {UniversityService} from '../../../shared/services/university.service';
import {PcbMappingService} from '../../../shared/services/pcb-mapping.service';

import {UtilsService} from '../../../shared/services/utils.service';
@Component({
    selector: 'app-university-fee-details',
    templateUrl: './university-fee-details.component.html',
    styleUrls: ['./university-fee-details.component.scss']
})
export class UniversityFeeDetailsComponent implements OnInit {
    public data: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    submitting: any = false;
    submitted: any = false;
    dataExists: any = false;
    university: any;
    pcbMappings: any;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };

    constructor(private sanitizer: DomSanitizer,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityFeeDetailsService: UniversityFeeDetailsService,
                private universityService: UniversityService,
                private pcbMappingService: PcbMappingService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
        this.getPCBMapping();
        this.universityFeeDetailsService.detailByAdmin(this.universityId).subscribe(data => {
            if (data && data['info']) {
                this.data = data['info'];
                this.dataExists = true;
            } else {
                this.dataExists = false;
            }
        });
    }

    getPCBMapping() {
        this.pcbMappingService.getByAdmin(this.universityId, {'page': -1}).subscribe(data => {
            const mappings = data ? data : [];
            this.pcbMappings = mappings.filter((mapping: any) => mapping?.course?.name && mapping?.course_curriculum?.course_fee);
        });
    }

    courseCurriculum(data: any) {
        this.router.navigateByUrl('course-curriculum/' + data.id);
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
            }
        });
    }

    submit() {
        let params = {
            'info': this.data ? UtilsService.encodeHtml(this.data) : ''
        };
        if (this.dataExists) {
            this.universityFeeDetailsService.updateByAdmin(this.universityId, params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        } else {
            this.universityFeeDetailsService.createByAdmin(this.universityId, params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        }
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
